module.exports = __webpack_public_path__ + "img/icon1.e0192b7e.png";